import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { useAuth } from "../../providers/authprovider";
import DepartmentsSettingsTable from "./components/DepartmentsSettingsTable";
import ProtocolArrivalSignature from "./components/ProtocolArrivalSignature";
import RajcompaniesSettingsTable from "./components/RajcompaniesSettingsTable";

export default function Settings() {
  const { settings } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const refreshSettings = async () => {
    setLoading(true);
    setError("");

    const result = await settings.fetchSettings();
    setLoading(false);

    if (!result?.success) {
      setData(null);
      setError(result?.error || "Nie udało się pobrać ustawień.");
      return;
    }

    setData(result.content || {});
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  return (
    <div className="container py-3">
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Ustawienia</h4>
        <Button variant="outline-secondary" onClick={refreshSettings} disabled={loading}>
          Odśwież
        </Button>
      </div>

      {loading && (
        <div className="mt-3 text-muted">
          <Spinner size="sm" className="me-2" />
          Pobieranie ustawień...
        </div>
      )}

      {error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <div className="mt-3">
          <ProtocolArrivalSignature
            settingsData={data || {}}
            onSettingsSaved={setData}
          />
          <RajcompaniesSettingsTable />
          <DepartmentsSettingsTable
            settingsData={data || {}}
            onSettingsSaved={setData}
          />
        </div>
      )}
    </div>
  );
}
